import ViewItemIssue from "../../../../components/@documents/item_issues/ViewItemIssue";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemIssueViewPage() {

    return (
        <ViewItemIssue 
            routeType={routeTypes.admin}
        />
    )
}